import axios from "axios";
import "./wbeditmodal.css"
import "./wbeditmodalDark.css"
import React, { useEffect, useRef, useState } from 'react';

import { Button, Img } from '@chakra-ui/react'
import Modal from 'react-bootstrap/Modal';
import { Input } from '@chakra-ui/react'
import { useToast } from '@chakra-ui/react'
import { useSelector } from "react-redux";



export default function EditModalwb({ vendorCodes, price, nmID }) {

  const [show, setShow] = useState(false);
  const [load, setload] = useState(false);
  const [index, setindex] = useState(0);
  const [data, setData] = useState([]);
  const [media, setMedia] = useState([]);
  const [files, setFiles] = useState([]);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const getDarkModoe = useSelector(darkModes => darkModes )
  const [inpvalue, setinpvalue] = useState("")
  const toast = useToast()

const showModalRef = useRef(null)

  useEffect(() => {
    setFiles([])
    // showModalRef.current.style.display = "none"
  }, [])

  const handleGetWb = async () => {
    setload(true)
    axios.get('/wildberis/getForEdit/api', { params: { vendorCodes } })
      .then(res => {
        setData(res.data.getRezult.data[0])
        setMedia(res.data.getRezult.data[0].mediaFiles)
         setShow(true)
        showModal()
        setload(false)
      }).catch(error => {
        setload(false)
      })

  }





  const handleEditArray = async (index, key, value) => {


    var tmp = {};
    tmp[key] = [value]
    data.characteristics[index] = tmp

  }

  const handleEditObject = async (index, key, value, type) => {


    var tmp = {};
    tmp[key] = value
    data.characteristics[index] = tmp
    console.log(data.characteristics);
  }

  const handleSendserver = async () => {
    setinpvalue(price)


    axios.post('/wildberis/carDupdate/api', {
      data
    })
      .then(function (response) {
        console.log(response);
        axios.post('/api/editUploadImage/api', formData, {
          params: {
            media,
            vendorCodes
          }
        })
          .then((response) => {
            console.log(response.data);
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .catch(function (error) {
        console.log(error);
      });


    axios.post('/wildberis/changePrice/api', {

      inpvalue,
      nmID
    })
      .then(function (response) {
        console.log(response);
        toast({
          position: "top",
          title: 'Хорошо',
          description: response.data.message,
          status: 'success',
          duration: 9000,
          isClosable: true,
        })
      })
      .catch(function (error) {
        console.log(error);
        toast({
          position: "top",
          title: 'Ошибка',
          description: error.response.data.message,
          status: 'error',
          duration: 9000,
          isClosable: true,
        })
      });
    const formData = new FormData();
    files.forEach((file) => {
      formData.append(`image`, file);
    });






  }

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles(files => [...files, ...selectedFiles]);



  };


  const handleSne = () => {

  }
  const handleDelete = (e) => {
    console.log(vendorCodes);
    let deletemedia = media.filter(item => item != e)
    setMedia(deletemedia)
  }


  const hanldeLOcalDelet = (e) => {

    let loacldelete = files.filter(item => item.lastModified != e.lastModified)
    setFiles(loacldelete)
  }


  const showModal = ()=>{
    showModalRef.current.style.display = "flex"
  }

  const closeModal = ()=>{
    showModalRef.current.style.display = "none"
  }

  return (
    <div className="wbEditContModal">
      {load ?
        <div className="custom-loaderWbTable"></div>
        :
        <span className="material-symbols-outlined openModalEdit" style={{color:'#3B79F6',cursor:"pointer"}} onClick={handleGetWb}>edit_note</span>
      }

      {/* <div id="myModal" class="modalEditWB"  ref={showModalRef}>


        <div className="modal-content">
          <div className="modal-header">
            <span className="close"  onClick={closeModal}>&times;</span>
          
          </div>
          <div className="modal-body">
          <div className="EditModalContMap">

<label htmlFor="" >Цена</label>
<Input placeholder='Basic usage' defaultValue={price} type="number" onChange={(e) => setinpvalue(e.target.value)} accept="image/*" />
            </div>

            {data.characteristics && data.characteristics?.map((item, index) => {


            let key = Object.keys(item)
            let values = Object.values(item)

            if (values[0] instanceof Array) {

              return (

                <div key={index} className="EditModalContMap">

                  <label htmlFor="" >{key}</label>
                  <Input placeholder={values[0]} defaultValue={values[0]} onChange={(e) => handleEditArray(index, key[0], e.target.value)} style={{ color: "#5E86DC" }} />
                </div>

              )
            } else {
              if (typeof values[0] == "number") {
                return (

                  <div key={index} className="EditModalContMap">
                    <label htmlFor="">{key}</label>
                    <Input placeholder={values[0]} defaultValue={values[0]} type="number" onChange={(e) => handleEditObject(index, key[0], Number(e.target.value), values[0])} style={{ color: "#5E86DC" }} />
                  </div>

                )
              } else {
                return (

                  <div key={index} className="EditModalContMap">
                    <label htmlFor="">{key}</label>
                    <Input placeholder={values[0]} defaultValue={values[0]} onChange={(e) => handleEditObject(index, key[0], e.target.value, values[0])} style={{ color: "#5E86DC" }} />
                  </div>

                )
              }

            }

            })}


              <div className='uploadPoto'>

              <label htmlFor="uploadWB" className='uploadfile' >
                <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="149" height="149" viewBox="0 0 149 149" fill="none">
  <path d="M143.225 55.2062C141.858 55.2241 140.552 55.7751 139.585 56.7419C138.619 57.7086 138.068 59.0147 138.05 60.3818V101.786L109.204 68.8008C107.372 66.8497 105.159 65.2947 102.702 64.2317C100.245 63.1688 97.5967 62.6204 94.9199 62.6204C92.243 62.6204 89.5945 63.1688 87.1378 64.2317C84.681 65.2947 82.468 66.8497 80.6353 68.8008L60.8301 91.4353L54.3433 83.5684C52.5559 81.4242 50.3189 79.6991 47.7908 78.5152C45.2627 77.3314 42.5052 76.7177 39.7137 76.7177C36.9221 76.7177 34.1647 77.3314 31.6366 78.5152C29.1085 79.6991 26.8715 81.4242 25.084 83.5684L10.3854 101.303V32.7787C10.4036 26.8361 12.7723 21.1422 16.9743 16.9401C21.1764 12.7381 26.8703 10.3694 32.8129 10.3512H88.0191C89.3918 10.3512 90.7082 9.80588 91.6788 8.83527C92.6494 7.86466 93.1947 6.54823 93.1947 5.17558C93.1947 3.80293 92.6494 2.4865 91.6788 1.51589C90.7082 0.545283 89.3918 0 88.0191 0H32.8129C24.1194 0 15.7821 3.45346 9.63486 9.60066C3.48767 15.7479 0.0342076 24.0852 0.0342076 32.7787V115.588C0.0016183 115.701 0.0016183 115.82 0.0342076 115.933C0.125092 124.567 3.61863 132.816 9.756 138.888C15.8934 144.961 24.1789 148.367 32.8129 148.367H115.622C124.221 148.35 132.468 144.954 138.587 138.913C144.705 132.872 148.205 124.669 148.332 116.071V60.3818C148.315 59.0264 147.773 57.7304 146.821 56.7655C145.869 55.8006 144.58 55.2418 143.225 55.2062ZM115.622 138.016H32.8129C27.1758 137.998 21.7521 135.857 17.6217 132.021C13.4913 128.185 10.957 122.934 10.5234 117.313L32.8129 90.1932C33.6478 89.263 34.6691 88.5191 35.8105 88.0099C36.9519 87.5006 38.1878 87.2374 39.4376 87.2374C40.6875 87.2374 41.9233 87.5006 43.0647 88.0099C44.2061 88.5191 45.2275 89.263 46.0624 90.1932L56.4826 102.753C56.9604 103.334 57.5609 103.802 58.2408 104.124C58.9208 104.446 59.6636 104.614 60.416 104.616C61.9061 104.534 63.3105 103.893 64.3494 102.822L88.0881 75.6325C88.9327 74.743 89.9494 74.0347 91.0765 73.5506C92.2035 73.0666 93.4173 72.817 94.6439 72.817C95.8704 72.817 97.0842 73.0666 98.2112 73.5506C99.3383 74.0347 100.355 74.743 101.2 75.6325L137.567 117.037C137.22 122.654 134.768 127.933 130.701 131.822C126.633 135.71 121.249 137.922 115.622 138.016Z" fill="#3B79F6"/>
  <path d="M20.7363 39.6795C20.7363 43.4328 21.8493 47.1018 23.9346 50.2226C26.0198 53.3434 28.9836 55.7757 32.4512 57.2121C35.9188 58.6484 39.7345 59.0242 43.4157 58.292C47.0969 57.5597 50.4783 55.7523 53.1323 53.0983C55.7863 50.4443 57.5937 47.0629 58.326 43.3817C59.0582 39.7005 58.6824 35.8848 57.2461 32.4172C55.8097 28.9496 53.3774 25.9858 50.2566 23.9006C47.1358 21.8153 43.4668 20.7023 39.7135 20.7023C34.6804 20.7023 29.8535 22.7017 26.2946 26.2606C22.7357 29.8195 20.7363 34.6464 20.7363 39.6795ZM48.3394 39.6795C48.3394 41.3855 47.8335 43.0533 46.8857 44.4718C45.9379 45.8903 44.5907 46.9959 43.0145 47.6488C41.4383 48.3017 39.7039 48.4725 38.0306 48.1397C36.3573 47.8069 34.8203 46.9853 33.614 45.7789C32.4076 44.5726 31.5861 43.0356 31.2532 41.3623C30.9204 39.689 31.0912 37.9546 31.7441 36.3784C32.397 34.8023 33.5026 33.4551 34.9211 32.5072C36.3397 31.5594 38.0074 31.0535 39.7135 31.0535C42.0012 31.0535 44.1953 31.9623 45.8129 33.58C47.4306 35.1977 48.3394 37.3917 48.3394 39.6795ZM101.82 31.0535H117.347V46.5802C117.347 47.9529 117.892 49.2693 118.863 50.2399C119.834 51.2105 121.15 51.7558 122.523 51.7558C123.895 51.7558 125.212 51.2105 126.182 50.2399C127.153 49.2693 127.698 47.9529 127.698 46.5802V31.0535H143.225C144.598 31.0535 145.914 30.5082 146.885 29.5376C147.855 28.567 148.401 27.2506 148.401 25.8779C148.401 24.5053 147.855 23.1888 146.885 22.2182C145.914 21.2476 144.598 20.7023 143.225 20.7023H127.698V5.17558C127.698 3.80293 127.153 2.4865 126.182 1.51589C125.212 0.545283 123.895 0 122.523 0C121.15 0 119.834 0.545283 118.863 1.51589C117.892 2.4865 117.347 3.80293 117.347 5.17558V20.7023H101.82C100.448 20.7023 99.1314 21.2476 98.1608 22.2182C97.1902 23.1888 96.6449 24.5053 96.6449 25.8779C96.6449 27.2506 97.1902 28.567 98.1608 29.5376C99.1314 30.5082 100.448 31.0535 101.82 31.0535Z" fill="#3B79F6"/>
</svg>
                  <input type="file" id='uploadWB' multiple onChange={(e) => handleFileChange(e)} style={{ display: "none" }} />
                </div>
                <p className='textCont'>Загрузить изображение</p>
              </label>


              <div className='uploadPhoto2'>

                {
                  files.sort((a, b) => a.name.localeCompare(b.name)).map((item, index) => {
                    console.log(item);
                    return <div key={index}>

                      <div className='delte'>
                        <div className='frame'>
                          <img src={URL.createObjectURL(item)} alt="" />
                          <span className="material-symbols-outlined" onClick={() => hanldeLOcalDelet(item)}>close</span>
                        
                        </div>
                      </div>



                    </div>
                  })
                }


                {
                  media?.map((item, index) => {
                    console.log(item);
                    return <div key={index}>

                      <div className='delte'>
                        <div className='frame'>
                          <img src={item} alt="" />
                          <span className="material-symbols-outlined" onClick={() => handleDelete(item)}>close</span>
                        </div>
                      </div>



                    </div>
                  })
                }
              </div>


              </div>
          </div>
          <div class="modal-footer">
          <button variant="secondary" className="closeModalBTN" onClick={closeModal}>
            Закрыть
          </button>
 
          <button colorScheme='blue' className="SHOWModalBTN" onClick={handleSendserver}>Редактировать</button>
          </div>
        </div>

      </div> */}

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        fullscreen={true}
       
          
      >
        {/* upload@ mobile tarberakum chi ashxatum  ozonum chi asxatum  vorohetev petq e poxenq bootstap modal*/}
        <Modal.Header style={{color:"#3B79F6"}}     className={getDarkModoe.ToggleDarkModeReducer.chekced?"modEditWBLightDarkHead":"modEditWBLightHead"}>
          <Modal.Title style={{ marginLeft: "auto", color: "#3B79F6" }}>Редактировать</Modal.Title>
        </Modal.Header>
        <Modal.Body  className={getDarkModoe.ToggleDarkModeReducer.chekced?"modEditWBLightDark":"modEditWBLight"}>
        <div className="EditModalContMap">

<label htmlFor="" >Цена</label>
<Input placeholder='Basic usage' defaultValue={price} type="number" onChange={(e) => setinpvalue(e.target.value)} accept="image/*" />
            </div>

            {data.characteristics && data.characteristics?.map((item, index) => {


            let key = Object.keys(item)
            let values = Object.values(item)

            if (values[0] instanceof Array) {

              return (

                <div key={index} className="EditModalContMap">

                  <label htmlFor="" >{key}</label>
                  <Input placeholder={values[0]} defaultValue={values[0]} onChange={(e) => handleEditArray(index, key[0], e.target.value)} style={{ color: "#5E86DC" }} />
                </div>

              )
            } else {
              if (typeof values[0] == "number") {
                return (

                  <div key={index} className="EditModalContMap">
                    <label htmlFor="">{key}</label>
                    <Input placeholder={values[0]} defaultValue={values[0]} type="number" onChange={(e) => handleEditObject(index, key[0], Number(e.target.value), values[0])} style={{ color: "#5E86DC" }} />
                  </div>

                )
              } else {
                return (

                  <div key={index} className="EditModalContMap">
                    <label htmlFor="">{key}</label>
                    <Input placeholder={values[0]} defaultValue={values[0]} onChange={(e) => handleEditObject(index, key[0], e.target.value, values[0])} style={{ color: "#5E86DC" }} />
                  </div>

                )
              }

            }

            })}


              <div className='uploadPoto'>

              <label htmlFor="uploadWB" className='uploadfile' >
                <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="149" height="149" viewBox="0 0 149 149" fill="none">
  <path d="M143.225 55.2062C141.858 55.2241 140.552 55.7751 139.585 56.7419C138.619 57.7086 138.068 59.0147 138.05 60.3818V101.786L109.204 68.8008C107.372 66.8497 105.159 65.2947 102.702 64.2317C100.245 63.1688 97.5967 62.6204 94.9199 62.6204C92.243 62.6204 89.5945 63.1688 87.1378 64.2317C84.681 65.2947 82.468 66.8497 80.6353 68.8008L60.8301 91.4353L54.3433 83.5684C52.5559 81.4242 50.3189 79.6991 47.7908 78.5152C45.2627 77.3314 42.5052 76.7177 39.7137 76.7177C36.9221 76.7177 34.1647 77.3314 31.6366 78.5152C29.1085 79.6991 26.8715 81.4242 25.084 83.5684L10.3854 101.303V32.7787C10.4036 26.8361 12.7723 21.1422 16.9743 16.9401C21.1764 12.7381 26.8703 10.3694 32.8129 10.3512H88.0191C89.3918 10.3512 90.7082 9.80588 91.6788 8.83527C92.6494 7.86466 93.1947 6.54823 93.1947 5.17558C93.1947 3.80293 92.6494 2.4865 91.6788 1.51589C90.7082 0.545283 89.3918 0 88.0191 0H32.8129C24.1194 0 15.7821 3.45346 9.63486 9.60066C3.48767 15.7479 0.0342076 24.0852 0.0342076 32.7787V115.588C0.0016183 115.701 0.0016183 115.82 0.0342076 115.933C0.125092 124.567 3.61863 132.816 9.756 138.888C15.8934 144.961 24.1789 148.367 32.8129 148.367H115.622C124.221 148.35 132.468 144.954 138.587 138.913C144.705 132.872 148.205 124.669 148.332 116.071V60.3818C148.315 59.0264 147.773 57.7304 146.821 56.7655C145.869 55.8006 144.58 55.2418 143.225 55.2062ZM115.622 138.016H32.8129C27.1758 137.998 21.7521 135.857 17.6217 132.021C13.4913 128.185 10.957 122.934 10.5234 117.313L32.8129 90.1932C33.6478 89.263 34.6691 88.5191 35.8105 88.0099C36.9519 87.5006 38.1878 87.2374 39.4376 87.2374C40.6875 87.2374 41.9233 87.5006 43.0647 88.0099C44.2061 88.5191 45.2275 89.263 46.0624 90.1932L56.4826 102.753C56.9604 103.334 57.5609 103.802 58.2408 104.124C58.9208 104.446 59.6636 104.614 60.416 104.616C61.9061 104.534 63.3105 103.893 64.3494 102.822L88.0881 75.6325C88.9327 74.743 89.9494 74.0347 91.0765 73.5506C92.2035 73.0666 93.4173 72.817 94.6439 72.817C95.8704 72.817 97.0842 73.0666 98.2112 73.5506C99.3383 74.0347 100.355 74.743 101.2 75.6325L137.567 117.037C137.22 122.654 134.768 127.933 130.701 131.822C126.633 135.71 121.249 137.922 115.622 138.016Z" fill="#3B79F6"/>
  <path d="M20.7363 39.6795C20.7363 43.4328 21.8493 47.1018 23.9346 50.2226C26.0198 53.3434 28.9836 55.7757 32.4512 57.2121C35.9188 58.6484 39.7345 59.0242 43.4157 58.292C47.0969 57.5597 50.4783 55.7523 53.1323 53.0983C55.7863 50.4443 57.5937 47.0629 58.326 43.3817C59.0582 39.7005 58.6824 35.8848 57.2461 32.4172C55.8097 28.9496 53.3774 25.9858 50.2566 23.9006C47.1358 21.8153 43.4668 20.7023 39.7135 20.7023C34.6804 20.7023 29.8535 22.7017 26.2946 26.2606C22.7357 29.8195 20.7363 34.6464 20.7363 39.6795ZM48.3394 39.6795C48.3394 41.3855 47.8335 43.0533 46.8857 44.4718C45.9379 45.8903 44.5907 46.9959 43.0145 47.6488C41.4383 48.3017 39.7039 48.4725 38.0306 48.1397C36.3573 47.8069 34.8203 46.9853 33.614 45.7789C32.4076 44.5726 31.5861 43.0356 31.2532 41.3623C30.9204 39.689 31.0912 37.9546 31.7441 36.3784C32.397 34.8023 33.5026 33.4551 34.9211 32.5072C36.3397 31.5594 38.0074 31.0535 39.7135 31.0535C42.0012 31.0535 44.1953 31.9623 45.8129 33.58C47.4306 35.1977 48.3394 37.3917 48.3394 39.6795ZM101.82 31.0535H117.347V46.5802C117.347 47.9529 117.892 49.2693 118.863 50.2399C119.834 51.2105 121.15 51.7558 122.523 51.7558C123.895 51.7558 125.212 51.2105 126.182 50.2399C127.153 49.2693 127.698 47.9529 127.698 46.5802V31.0535H143.225C144.598 31.0535 145.914 30.5082 146.885 29.5376C147.855 28.567 148.401 27.2506 148.401 25.8779C148.401 24.5053 147.855 23.1888 146.885 22.2182C145.914 21.2476 144.598 20.7023 143.225 20.7023H127.698V5.17558C127.698 3.80293 127.153 2.4865 126.182 1.51589C125.212 0.545283 123.895 0 122.523 0C121.15 0 119.834 0.545283 118.863 1.51589C117.892 2.4865 117.347 3.80293 117.347 5.17558V20.7023H101.82C100.448 20.7023 99.1314 21.2476 98.1608 22.2182C97.1902 23.1888 96.6449 24.5053 96.6449 25.8779C96.6449 27.2506 97.1902 28.567 98.1608 29.5376C99.1314 30.5082 100.448 31.0535 101.82 31.0535Z" fill="#3B79F6"/>
</svg>
                  <input type="file" id='uploadWB' multiple onChange={(e) => handleFileChange(e)} style={{ display: "none" }} />
                </div>
                <p className='textCont'>Загрузить изображение</p>
              </label>


              <div className='uploadPhoto2'>

                {
                  files.sort((a, b) => a.name.localeCompare(b.name)).map((item, index) => {
                    console.log(item);
                    return <div key={index}>

                      <div className='delte'>
                        <div className='frame'>
                          <img src={URL.createObjectURL(item)} alt="" />
                          <span className="material-symbols-outlined" onClick={() => hanldeLOcalDelet(item)}>close</span>
                          {/* <span className="material-symbols-outlined" onClick={()=> handleDeletImage(index)}>delete</span> */}
                        </div>
                      </div>



                    </div>
                  })
                }


                {
                  media?.map((item, index) => {
                    console.log(item);
                    return <div key={index}>

                      <div className='delte'>
                        <div className='frame'>
                          <img src={item} alt="" />
                          <span className="material-symbols-outlined" onClick={() => handleDelete(item)}>close</span>
                        </div>
                      </div>



                    </div>
                  })
                }
              </div>


              </div>
        </Modal.Body>
        <Modal.Footer  className={getDarkModoe.ToggleDarkModeReducer.chekced?"modEditWBDarkFooter":"modEditWBLightFooter"}>
          <button className="closeModalBTN" variant="secondary" onClick={handleClose}>
            Закрыть
          </button>

          <button className="SHOWModalBTN" colorScheme='blue' onClick={handleSendserver}>Редактировать</button>
        </Modal.Footer>
      </Modal>

    </div>
  )
}